export { default } from './LinkableLibrary';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/LinkableLibrary/index.js